import { render, staticRenderFns } from "./SimpleListWithImages.vue?vue&type=template&id=7beb8ec5&"
import script from "./SimpleListWithImages.vue?vue&type=script&lang=js&"
export * from "./SimpleListWithImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports